// extracted by mini-css-extract-plugin
export default {"alert":"reset_vacancies_row-module___alert___e47c7da9","tooltipTableWrapper":"reset_vacancies_row-module___tooltipTableWrapper___fa68c67b"};